/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockBubbleSettings = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The DashboardPageBlockBubbleSettings model module.
   * @module model/DashboardPageBlockBubbleSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockBubbleSettings</code>.
   * @alias module:model/DashboardPageBlockBubbleSettings
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>DashboardPageBlockBubbleSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockBubbleSettings} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockBubbleSettings} The populated <code>DashboardPageBlockBubbleSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TrackingLevelID')) {
        obj['TrackingLevelID'] = ApiClient.convertToType(data['TrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('XAxisIndicatorID')) {
        obj['XAxisIndicatorID'] = ApiClient.convertToType(data['XAxisIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('YAxisIndicatorID')) {
        obj['YAxisIndicatorID'] = ApiClient.convertToType(data['YAxisIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SizeAxisIndicatorID')) {
        obj['SizeAxisIndicatorID'] = ApiClient.convertToType(data['SizeAxisIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('XAxisDimensionID')) {
        obj['XAxisDimensionID'] = ApiClient.convertToType(data['XAxisDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('YAxisDimensionID')) {
        obj['YAxisDimensionID'] = ApiClient.convertToType(data['YAxisDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('SizeAxisDimensionID')) {
        obj['SizeAxisDimensionID'] = ApiClient.convertToType(data['SizeAxisDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TrackingLevelID
   */
  exports.prototype['TrackingLevelID'] = undefined;
  /**
   * @member {Integer} PeriodTypeID
   */
  exports.prototype['PeriodTypeID'] = undefined;
  /**
   * @member {Integer} XAxisIndicatorID
   */
  exports.prototype['XAxisIndicatorID'] = undefined;
  /**
   * @member {Integer} YAxisIndicatorID
   */
  exports.prototype['YAxisIndicatorID'] = undefined;
  /**
   * @member {Integer} SizeAxisIndicatorID
   */
  exports.prototype['SizeAxisIndicatorID'] = undefined;
  /**
   * @member {Integer} XAxisDimensionID
   * @default 0
   */
  exports.prototype['XAxisDimensionID'] = 0;
  /**
   * @member {Integer} YAxisDimensionID
   * @default 0
   */
  exports.prototype['YAxisDimensionID'] = 0;
  /**
   * @member {Integer} SizeAxisDimensionID
   * @default 0
   */
  exports.prototype['SizeAxisDimensionID'] = 0;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


